// src/components/RequestReschedule.js
import React from "react";
import { Modal, Button } from "react-bootstrap";

const RequestReschedule = ({ show, onClose, onSubmit, reason, setReason }) => {
  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Request Reschedule</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="form-group">
          <label>
            Reason for rescheduling <span className="text-danger">*</span>
          </label>
          <textarea
            className="form-control"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            rows="4"
            required
          ></textarea>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="success" onClick={onSubmit} disabled={!reason.trim()}>
          Submit
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RequestReschedule;
